// removed by extract-text-webpack-plugin
module.exports = {"owner":"_3AZeb","heading":"RzMYU","owner-info":"_2rWU_","owner-raising-for":"_3LqTv","name":"_3OxNC","avatar":"hrjS6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/Owner.scss
// module id = ./src/components/Page/Owner.scss
// module chunks = 5